import { inject } from '@angular/core';
import { Router} from '@angular/router';
import { AppContext } from "src/app/shared/services/app.context";
import {URL_PAGE} from "../../enums/url.pages.enum";

export const HomeGuard = () => {
  const appContext: AppContext = inject(AppContext);
  const router: Router = inject(Router);

  if((window.innerWidth > 400 && appContext.currentUserHasRole()) || window.innerWidth < 400 && appContext.currentUserHasExpeditionManuelRole()) {
    return true;
  }
  if (window.innerWidth < 400 && !appContext.currentUserHasExpeditionManuelRole() && router.url.endsWith(URL_PAGE.BIENVENUE)) {
    return router.navigate([URL_PAGE.UNAUTHORIZED]);
  }

  return router.navigate([URL_PAGE.BIENVENUE]);
}
